export default __webpack_public_path__ + "static/media/01.d9ecf277.png";